import React from 'react'
import {connect} from 'react-redux'
import {Field, formValueSelector, reduxForm} from 'redux-form'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faRedo} from "@fortawesome/free-solid-svg-icons";
import {PAYPAL, APPLE_PAY} from '../common/PaymentMethodsConstants';
import PaypalForm from './products/PaypalForm';
import ApplePayForm from './products/ApplePayForm';

let ButtonForm = props => {
  const {handleSubmit, reset, submitting, onPrevious, applepay, paypal, paymentMethods, productValue} = props;

  return (
    <div>
      <h3>Button Widget Form Config</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="merchantId">Merchant ID</label>
          <Field className="form-control" name="merchantId" component="input" type="text" disabled={true}/>
        </div>

        <div className="form-group">
          <label htmlFor="language">Language</label>
          <Field className="form-control" name="language" component="input" type="text"/>
        </div>

        <div>
          <h4>Risk settings:</h4>
          <div className="form-group">
            <div className="checkbox">
              <label>
                <Field name="deviceIdent" component="input" type="checkbox"/> <b>Device Ident</b>
              </label>
            </div>
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="product">Product</label>
          <Field className="form-control" component="select" name="product">
            {paymentMethods.map(option => {
              return (
                <option
                  key={option.key}
                  value={option.value}
                  label={option.key}>{option.key}
                </option>
              );
            })}
          </Field>
        </div>

        { productValue === PAYPAL && <PaypalForm paypal={paypal} />}

        { productValue === APPLE_PAY && <ApplePayForm applepay={applepay} />}

        <div className="hr-line-dashed"></div>
        <div className="form-group m-b-none">
          <div className="col-xs-12">
            <div className="col-lg-4 col-md-4 col-xs-12 m-b-xs">
              <button type="button" className="btn btn-primary2 col-xs-12" onClick={onPrevious}>
                <FontAwesomeIcon icon={faChevronLeft}/>
                <span className="btn-text">Previous</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 text-center">
              <button type="button" className="btn btn-primary2 col-xs-12 m-b-xs" disabled={submitting} onClick={reset}>
                <FontAwesomeIcon icon={faRedo}/>
                <span className="btn-text">Reset</span>
              </button>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-12 m-b-xs">
              <button type="submit" className="btn btn-primary col-xs-12">
                <span className="btn-text">Init Button Widget</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
};

ButtonForm = reduxForm({
  form: 'button'
})(ButtonForm);

const selector = formValueSelector('button');

ButtonForm = connect(
  state => {
    const initialValues = {
      product: APPLE_PAY,
      merchantId: state.config.environment.merchantId,
      orderId: state.order.order.orderId,
      order: state.order.order,
      language: 'en',
      deviceIdent: null,
      applepay: {
        applepayCallbacks: true,
        merchantIdentifier: 'merchant.com.concardis.payengine.applepay.test',
        domainName: '66493564.ngrok.io',
        validateMerchantUrl: 'https://payengine.qaiware.org/session-server',
        displayName: 'Test merchant for Apple Pay',
        countryCode: 'DE',
        useBillingAndShipping: false,
        stylesUsage: {
          general: true,
          type: true,
          color: true,
          width: true,
          height: true
        },
        styles: {
          type: 'plain',
          color: 'black',
          width: '100%',
          height: '32px'
        }
      },
      paypal: {
        paypalRecurringBillingAgreement: null,
        paypalCallbacks: true,
        stylesUsage: {
          general: true,
          label: true,
          size: true,
          tagline: false,
          color: true,
          shape: true
        },
        styles: {
          label: 'paypal',
          size: 'responsive',
          color: 'gold',
          shape: 'pill'
        }
      }
    };

    return {
      initialValues,
      paypal: selector(state, 'paypal'),
      applepay: selector(state, 'applepay'),
      productValue: selector(state, 'product')
    };
  }
)(ButtonForm);

export default ButtonForm;



// WEBPACK FOOTER //
// ./src/button/ButtonForm.js